import React from 'react';

import SvgIcon from '@mui/material/SvgIcon';

interface Props {
    color?: string;
    opacity?: string;
    fillOpacity?: string;
    size?: number;
}

export const CustomSportsMMA = ({ color, opacity = '1', fillOpacity = '1', size = 20 }: Props): JSX.Element => (
    <SvgIcon style={{ width: size, height: size }} viewBox={`0 0 ${size} ${size}`}>
        <path
            d={
                'M8.33333 18.333L7.91667 10.833L5.27083 9.31217L4.97917 10.3955L6.66667 13.333L5.22917 14.1663L3.16667 10.6247L4.16667 7.04134L8.95833 4.29134L6.66667 1.99967L7.83333 0.833008L11.6667 4.64551L8.66667 6.37467L9.66667 7.24967L16.5 1.66634L17.5 2.83301L10.4167 9.99967L10 18.333H8.33333ZM4.16667 5.83301C3.70833 5.83301 3.31597 5.66981 2.98958 5.34342C2.66319 5.01704 2.5 4.62467 2.5 4.16634C2.5 3.70801 2.66319 3.31565 2.98958 2.98926C3.31597 2.66287 3.70833 2.49967 4.16667 2.49967C4.625 2.49967 5.01736 2.66287 5.34375 2.98926C5.67014 3.31565 5.83333 3.70801 5.83333 4.16634C5.83333 4.62467 5.67014 5.01704 5.34375 5.34342C5.01736 5.66981 4.625 5.83301 4.16667 5.83301Z'
            }
            fill={color}
            opacity={opacity}
            fillOpacity={fillOpacity}
        />
    </SvgIcon>
);
